import { Components, Theme } from '@mui/material/styles';

export const muiPaginationOverride: Components<Theme>['MuiPagination'] = {
  styleOverrides: {},
};
